import isNil from 'lodash/isNil';

import { HTTP_STATUS_UNAUTHORIZED } from './httpUtils';

const SESSION_RETRY_BASE_DELAY_MS = 1_000;
const SESSION_RETRY_MAX_DELAY_MS = 30_000;

export enum SessionQueryResolution {
  PENDING = 'PENDING',
  SIGNED_IN = 'SIGNED_IN',
  SIGNED_OUT = 'SIGNED_OUT',
  UNAVAILABLE = 'UNAVAILABLE',
}

export interface SessionQueryState {
  data: { user?: object | null } | null;
  error: { message: string; status?: number } | null;
  isPending: boolean;
}

export const resolveSessionQuery = ({ data, error, isPending }: SessionQueryState): SessionQueryResolution => {
  if (isPending) {
    return SessionQueryResolution.PENDING;
  }
  if (!isNil(data?.user)) {
    return SessionQueryResolution.SIGNED_IN;
  }
  if (!isNil(error) && error.status !== HTTP_STATUS_UNAUTHORIZED) {
    return SessionQueryResolution.UNAVAILABLE;
  }
  return SessionQueryResolution.SIGNED_OUT;
};

export const getSessionRetryDelayMs = (attempt: number): number =>
  Math.min(SESSION_RETRY_BASE_DELAY_MS * 2 ** attempt, SESSION_RETRY_MAX_DELAY_MS);
